const id_master_price_tier = {
    "": "tingkat harga",
    add: "tambah tingkat harga",
    edit: "ubah tingkat harga",

    label: {
        name: 'nama tingkat harga'
    },

    error: {
        create: 'Gagal membuat tingkat harga',
        edit: 'Gagal mengubah tingkat harga',
        delete: 'Gagal menghapus tingkat harga',
        name: 'Nama tingkat harga tidak boleh kosong',
    },

    success: {
        create: 'Berhasil membuat tingkat harga',
        edit: 'Berhasil mengubah tingkat harga',
        delete: 'Berhasil menghapus tingkat harga',
    },
}

export default id_master_price_tier;